import { writable } from "svelte/store";
import type { TrEvent, TrEventPayload } from "./tr.types";

// See https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data
// for information on the custom data fields.

// Standard events https://developers.facebook.com/docs/meta-pixel/reference#standard-events

function createTrStore() {
    const store = writable<TrEvent[] | TrEventPayload[]>([]);

    store.subscribe((queue) => {
        let next = queue.length && queue.shift();
        while (next) {
            let sourceUrl = window.location.href;
            if ("sourceUrl" in next && typeof next.sourceUrl === "string") {
                sourceUrl = next.sourceUrl;
            }

            makeRequest({ ...next, sourceUrl });
            next = queue.shift();
        }
    });

    return {
        subscribe: store.subscribe,
        add: (payload: TrEvent | TrEventPayload) => {
            store.update((prev) => [...prev, payload]);
        },
    };
}

export const trStore = createTrStore();

function makeRequest(rec: TrEventPayload) {
    const url = "/server-api/tr";
    const { event, data, sourceUrl } = rec;
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ event, data, sourceUrl }),
    });
}
